export const environment = {
  env: "develop",
  production: false,
  backendEndpoint: "https://dev-backend.hub.bizcuit.nl"
};
